import {Analytics} from "@plaudit/analytics";

Analytics.setup(); // This will setup the system and return an instance of Analytics.

window.addEventListener("message", (event: MessageEvent) => {
	if (
		typeof event.data === "object"
		&& event.origin.indexOf("jotform.com") !== -1
		&& event.data.action === "submission-completed"
	) {
		let formName = "Unknown";
		if (event.target !== undefined) {
			const iframe = (event.target as any).iframe || (event.target as any).ifr;
			if (
				iframe !== undefined
				&& iframe.title !== undefined
				&& iframe.title.length > 0
			) {
				formName = iframe.title
			}
		}
		const analytics = Analytics.getInstance();
		analytics.trackEvent("JotForm", "Submitted", formName);
	}
}, false);